// All backend calls used by the conversation canvas builder, in one place.
// URLs and payload shapes are kept identical to what the module sent before
// this file existed, so the wire contract with the Spring backend is unchanged.

import axios from 'axios';

const jsonHeaders = {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
};

export function getConversation(conversationId) {
    return axios.get('/api/conversations/' + conversationId, { withCredentials: true });
}

export function getQuestions(conversationId) {
    return axios.get('/api/answers/?conversation=' + conversationId, { withCredentials: true });
}

export function getEstimationGroups(conversationId) {
    return axios.get('/api/estimationgroup?conversation=' + conversationId, { withCredentials: true });
}

export function getStages(stageTypeId) {
    return axios.get('/api/stages?stageType=' + stageTypeId, { withCredentials: true });
}

export function saveCoordinates(node) {
    const formData = { id: node.id, x: node.x, y: node.y };
    return axios.post('/api/answers/coordinates', JSON.stringify(formData), jsonHeaders);
}

export function createQuestion({ text, conversationId }) {
    const formData = {
        answerTypeId: 1,
        text,
        conversationId,
        isLast: 2,
    };
    return axios.post('/api/answers', JSON.stringify(formData), jsonHeaders);
}

export function saveConnector({ text, fromId, nextId, isRight, clasification, estimationGroup, point, stage, word, url }) {
    const formData = { text, fromId, nextId, isRight, clasification, estimationGroup, point, stage, word: word || null, url: url || null };
    return axios.post('/api/answerconnectors', JSON.stringify(formData), jsonHeaders);
}

export function deleteConnector(id) {
    return axios.delete('/api/answerconnectors/' + id, jsonHeaders);
}

export function deleteQuestion(id) {
    return axios.delete('/api/answers/' + id, jsonHeaders);
}

export function saveQuestionText(id, text) {
    return axios.put('/api/answers/' + id, { id, text }, jsonHeaders);
}

export function updateConversation(id, payload) {
    return axios.put('/api/conversations/' + id, payload, jsonHeaders);
}

export function getEstimationFunctions() {
    return axios.get('/api/estimationfunctions', { withCredentials: true });
}

export function createEstimationGroup(name, conversationId) {
    return axios.post('/api/estimationgroup', { name, conversation: conversationId }, jsonHeaders);
}

export function deleteEstimationGroup(id) {
    return axios.delete('/api/estimationgroup/' + id, jsonHeaders);
}

export function getStageTypes() {
    return axios.get('/api/stage-types', { withCredentials: true });
}

export function getLevels() {
    return axios.get('/api/levels', { withCredentials: true });
}

export function getConversationTypes() {
    return axios.get('/api/conversationtypes', { withCredentials: true });
}

export function getConversationStats(conversationId) {
    return axios.get('/api/messages/stats/' + conversationId, { withCredentials: true });
}

export function updateTags(conversationId, tagNames) {
    return axios.put('/api/conversations/' + conversationId + '/tags', JSON.stringify(tagNames), jsonHeaders);
}

export function generateTags(conversationId) {
    return axios.post('/api/ai/generate-tags/' + conversationId, null, { withCredentials: true });
}

export function getBotErrorsForConversation(conversationId) {
    return axios.get('/api/bot-errors/by-conversation/' + conversationId, { withCredentials: true });
}

export function assignConversationToUser(conversationId, { studentId, clientId }) {
    const formData = { conversationId };
    if (clientId) {
        formData.client = clientId;
    } else if (studentId) {
        formData.student = studentId;
    }
    return axios.post('/api/conversationprogress', JSON.stringify(formData), jsonHeaders);
}
